/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';


class FileDependentDirective {
    public restrict = 'E';
    public scope = {};
    public template;
    public parentObj;

    constructor() {
        this.restrict = 'E';
        this.scope = true;
        this.template = `
        <div class="card">
            <div ng-repeat="data in typeArray track by $index">
                <div id="{{ariaId}}" class="card-header" data-toggle="collapse" data-target="#collapse{{$index}}" 
                        aria-expanded="false" aria-controls="#{{collapseId}}" ng-click="C.selectDependant($index)">
                    <div class="row">
                        <div style="float: right; padding-right: 20px;">
                            <md-icon class="drop-arrow" style="margin-bottom: -10px;" md-font-library="material-icons">keyboard_arrow_down</md-icon>
                        </div>
                        <div class="accordian-card-title" style="margin-top: 10px;">
                            {{data.name}} ({{data.relation}})
                        </div>
                    </div>
                </div>
                <div id="collapse{{$index}}" class="collapse" aria-labelledby="{{ariaId}}">
                    <div class="card-body">
                    <table ng-if"queryType == dependentDocs" id="highlightElement22" style="text-align-last: center" 
                            class="m-t-20 table table-material relativePosition whiteBackground">
                        <thead>
                        <tr>
                            <th class="b-word first_col sorted_by_this">Document Type:</th>
                            <th class="d-none d-md-table-cell">Number</th>
                            <th class="d-none d-md-table-cell">Expiry Date</th>
                            <th class="d-none d-md-table-cell">File</th>
                            <th class="d-none d-md-table-cell">Edit</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="first_col sorted_by_this">Visa</td>
                            <td class="d-none d-md-table-cell">{{data.visa.number || "---"}}</td>
                            <td class="d-none d-md-table-cell">{{(data.visa.expiry_date | date: 'dd.MM.yyyy') || "---"}}</td>
                            <td lass="p-0 d-none d-md-table-cell">
                                <md-button ng-if="C.checkFile($index, 'visa')" href="{{data.visa.file}}" target="_blank" 
                                    ng-click="C.emitEvent('employee.profile.datas.doc.visa.download')" class="md-icon-button md-primary">
                                    <md-icon md-font-library="material-icons" class="p-0">cloud_download</md-icon>
                                </md-button>
                            </td>
                            <td class="p-0 d-none d-md-table-cell">
                                <md-button type="button"  
                                    ng-click="C.documentEditModal('visa', $index); C.addEditDependantsDocuments();"
                                    class="md-icon-button md-primary">
                                    <md-icon md-font-library="material-icons" class="p-0">edit</md-icon>
                                </md-button>
                                <md-button type="button" ng-if="C.checkFile($index, 'visa') && C.isAdmin"
                                        ng-click="C.documentDeleteModal($index,'visa');" 
                                        class="md-icon md-warn cus-md-icon-button m-0">
                                    <md-icon md-font-library="material-icons" class="p-0">delete_forever</md-icon>
                                </md-button>
                            </td>
                        </tr>
                        <tr>
                            <td class="first_col sorted_by_this">Passport</td>
                            <td class="d-none d-md-table-cell">{{data.passport.number || "---"}}</td>
                            <td class="d-none d-md-table-cell">{{(data.passport.expiry_date | date: 'dd.MM.yyyy') || "---"}}</td>
                            <td>
                            <md-button ng-if="C.checkFile($index, 'passport')" 
                                    href="{{data.passport.file}}" target="_blank" 
                                    ng-click="C.emitEvent('employee.profile.datas.doc.passport.download')" class="md-icon-button md-primary">
                                <md-icon md-font-library="material-icons" class="p-0">cloud_download</md-icon>
                            </md-button>
                            </td>
                            <td class="p-0 d-none d-md-table-cell">
                                <md-button type="button"  
                                    ng-click="C.documentEditModal('passport', $index); C.addEditDependantsDocuments();"
                                    class="md-icon-button md-primary">
                                    <md-icon md-font-library="material-icons" class="p-0">edit</md-icon>
                                </md-button>
                                <md-button type="button" ng-if="C.checkFile($index, 'passport') && C.isAdmin"
                                        ng-click="C.documentDeleteModal($index,'passport');" 
                                        class="md-icon md-warn cus-md-icon-button m-0">
                                    <md-icon md-font-library="material-icons" class="p-0">delete_forever</md-icon>
                                </md-button>
                            </td>
                        </tr>
                        <tr>
                            <td class="first_col sorted_by_this">Emirates ID</td>
                            <td class="d-none d-md-table-cell">{{data.uae_identity_card.number || "---"}}</td>
                            <td class="d-none d-md-table-cell">{{(data.uae_identity_card.expiry_date | date: 'dd.MM.yyyy') || "---"}}</td>
                            <td>
                            <md-button ng-if="C.checkFile($index, 'uae_identity_card')" href="{{data.uae_identity_card.file}}" target="_blank" ng-click="C.emitEvent('employee.profile.datas.doc.emirates_id.download')" class="md-icon-button md-primary">
                                <md-icon md-font-library="material-icons" class="p-0">cloud_download</md-icon>
                            </md-button>
                            </td>
                            <td class="p-0 d-none d-md-table-cell">
                                <md-button type="button"  
                                    ng-click="C.documentEditModal('uae_identity_card', $index); C.addEditDependantsDocuments();"
                                    class="md-icon-button md-primary">
                                    <md-icon md-font-library="material-icons" class="p-0">edit</md-icon>
                                </md-button>
                                <md-button type="button" ng-if="C.checkFile($index, 'uae_identity_card') && C.isAdmin"
                                        ng-click="C.documentDeleteModal($index,'uae_identity_card');" 
                                        class="md-icon md-warn cus-md-icon-button m-0">
                                    <md-icon md-font-library="material-icons" class="p-0">delete_forever</md-icon>
                                </md-button>
                            </td>
                        </tr>
                        <tr>
                            <td class="first_col sorted_by_this">Medical Insurance Card</td>
                            <td class="d-none d-md-table-cell">{{data.med_insurance_card.number || "---"}}</td>
                            <td class="d-none d-md-table-cell">{{(data.med_insurance_card.expiry_date | date: 'dd.MM.yyyy') || "---"}}</td>
                            <td>
                            <md-button ng-if="C.checkFile($index, 'med_insurance_card')" href="{{data.med_insurance_card.file}}" 
                                    target="_blank" ng-click="C.emitEvent('employee.profile.datas.doc.medical_insurance_card.download')" 
                                    class="md-icon-button md-primary">
                                <md-icon md-font-library="material-icons" class="p-0">cloud_download</md-icon>
                            </md-button>
                            </td>
                            <td class="p-0 d-none d-md-table-cell">
                                <md-button type="button"  
                                    ng-click="C.documentEditModal('med_insurance_card', $index); C.addEditDependantsDocuments();"
                                    class="md-icon-button md-primary">
                                    <md-icon md-font-library="material-icons" class="p-0">edit</md-icon>
                                </md-button>
                                <md-button type="button" ng-if="C.checkFile($index, 'med_insurance_card') && C.isAdmin"
                                        ng-click="C.documentDeleteModal($index,'med_insurance_card');" 
                                        class="md-icon md-warn cus-md-icon-button m-0">
                                    <md-icon md-font-library="material-icons" class="p-0">delete_forever</md-icon>
                                </md-button>
                            </td>
                        </tr>
                        <tr>
                            <td class="first_col sorted_by_this">Table of Benefits</td>
                            <td class="d-none d-md-table-cell"></td>
                            <td class="d-none d-md-table-cell"></td>
                            <td>
                            <md-button ng-if="C.checkFile($index, 'tob')" href="{{data.tob.file}}" target="_blank" ng-click="C.emitEvent('employee.profile.datas.doc.tob.download')" class="md-icon-button md-primary">
                                <md-icon md-font-library="material-icons" class="p-0">cloud_download</md-icon>
                            </md-button>
                            </td>
                            <td class="p-0 d-none d-md-table-cell">
                                <md-button type="button"  
                                    ng-click="C.documentEditModal('tob', $index); C.addEditDependantsDocuments();"
                                    class="md-icon-button md-primary">
                                    <md-icon md-font-library="material-icons" class="p-0">edit</md-icon>
                                </md-button>
                                <md-button type="button" ng-if="C.checkFile($index, 'tob') && C.isAdmin"
                                        ng-click="C.documentDeleteModal($index,'tob');" 
                                        class="md-icon md-warn cus-md-icon-button m-0">
                                    <md-icon md-font-library="material-icons" class="p-0">delete_forever</md-icon>
                                </md-button>
                            </td>
                        </tr>
                        <tr>
                            <td class="first_col sorted_by_this">Network List</td>
                            <td class="d-none d-md-table-cell"></td>
                            <td class="d-none d-md-table-cell"></td>
                            <td>
                            <md-button ng-if="C.checkFile($index, 'network_list')" href="{{data.network_list.file}}" 
                                    target="_blank" ng-click="C.emitEvent('employee.profile.datas.doc.network_list.download')" 
                                    class="md-icon-button md-primary">
                                <md-icon md-font-library="material-icons" class="p-0">cloud_download</md-icon>
                            </md-button>
                            </td>
                            <td class="p-0 d-none d-md-table-cell">
                                <md-button type="button"  
                                    ng-click="C.documentEditModal('network_list', $index); C.addEditDependantsDocuments();"
                                    class="md-icon-button md-primary">
                                    <md-icon md-font-library="material-icons" class="p-0">edit</md-icon>
                                </md-button>
                                <md-button type="button" ng-if="C.checkFile($index, 'network_list') && C.isAdmin"
                                        ng-click="C.documentDeleteModal($index,'network_list');" 
                                        class="md-icon md-warn cus-md-icon-button m-0">
                                    <md-icon md-font-library="material-icons" class="p-0">delete_forever</md-icon>
                                </md-button>
                            </td>
                        </tr>
                    </tbody>
                    </div>
                </div>
            </div>
        </div>
            
        `;
    }


    public link = ($scope: any, $element: any, attrs: any): void  => { 
        $scope.typeArray = [];
        $scope.queryType = attrs.queryType;
        $scope.$watch(() => attrs.dependantData, (n) => {
            if (n !== '') {
                $scope.typeArray = JSON.parse(n);
            }
        });
    }

    public static DirectiveFn(): FileDependentDirective {
        return new FileDependentDirective();
    }
}

FileDependentDirective.DirectiveFn.$inject = [];

angular.module('beneple.global').directive('dependantTab', FileDependentDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/file_dependant.directive.ts